"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Save = void 0;
var react_1 = __importDefault(require("react"));
var storybook_1 = require("@eyecons/storybook");
var prop_types_1 = __importDefault(require("prop-types"));
var ra_fetch_1 = require("ra-fetch");
var Save = function (_a) {
    var _b = _a.team, team = _b === void 0 ? {} : _b, channel = _a.channel, teams = _a.teams, setTeams = _a.setTeams, onSubmit = _a.onSubmit;
    var competitions = ra_fetch_1.useApi('backend')
        .index('channels', { type: 'competition', sport_id: channel.sport_id })[0];
    var _c = storybook_1.Helpers.useSave('backend', 'teams', {
        id: team.id,
        name: team.name || '',
        label: team.label || '',
        competition_id: team.competition ? team.competition.id : '',
        club_id: team.club ? team.club.id : channel.id,
    }, {}, {}, setTeams, teams), saveTeam = _c[0], setTeam = _c[1], submitTeam = _c[2];
    function onClickSubmit() {
        submitTeam().then(function (response) {
            if (!response.errors.length) {
                setModal({
                    content: function () { return react_1.default.createElement(storybook_1.Forms.Success, { title: 'Je team is succesvol opgeslagen', onClose: onSubmit }); }
                });
            }
        });
    }
    return react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(storybook_1.Texts.Heading, { type: 'h3', appendClassname: 'mb-4' }, team.id ? "Team bewerken: " + team.label : 'Team aanmaken'),
        react_1.default.createElement(storybook_1.Forms.Field, null,
            react_1.default.createElement(storybook_1.Texts.Label, null, "Slug"),
            react_1.default.createElement(storybook_1.Forms.Input, { placeholder: 'slug', onChange: function (name) { return setTeam({ name: name }); }, value: saveTeam.data.name })),
        react_1.default.createElement(storybook_1.Forms.Field, null,
            react_1.default.createElement(storybook_1.Texts.Label, null, "Label"),
            react_1.default.createElement(storybook_1.Forms.Input, { placeholder: 'label', onChange: function (label) { return setTeam({ label: label }); }, value: saveTeam.data.label })),
        !competitions.loading && react_1.default.createElement(storybook_1.Forms.Field, null,
            react_1.default.createElement(storybook_1.Texts.Label, null, "Competitie"),
            react_1.default.createElement(storybook_1.Forms.Select, { onChange: function (competition_id) { return setTeam({ competition_id: competition_id }); }, value: saveTeam.data.competition_id },
                react_1.default.createElement("option", null, "Kies een competitie"),
                competitions.data.map(function (competition, index) {
                    return react_1.default.createElement("option", { key: index, value: competition.id }, competition.label);
                }))),
        react_1.default.createElement(storybook_1.Forms.Buttons, { loading: team.loading, errors: team.errors, title: 'Opslaan', submit: onClickSubmit }));
};
exports.Save = Save;
exports.Save.propTypes = {
    /**
     * The route to send the edit request to
     */
    route: prop_types_1.default.string,
    /**
     * The route params for the record to be editd for example: {{id: 1}}
     */
    params: prop_types_1.default.object,
    /**
     * The record title to be editd
     */
    title: prop_types_1.default.string,
};
